import { useAuthorizedSpends } from './useAuthorizedSpends';

export const useAuthorizedSpendsWithExclusions = (baseParams, exclusionFilters) => {
  // Call 1: Without exclusions - for accurate spend totals and items
  const {
    authorizedSpends,
    meta: displayMeta,
    isLoading: isLoadingWithoutExclusions,
  } = useAuthorizedSpends({
    ...baseParams,
  });

  // Call 2: With exclusions - only when needed to get accurate available_cap
  const {
    meta: capMeta,
    isLoading: isLoadingWithExclusions,
  } = useAuthorizedSpends({
    ...baseParams,
    enabled: baseParams.enabled && !!exclusionFilters,
    excludeServiceAuthorizations: exclusionFilters,
  });

  const meta = {
    ...displayMeta,
    ...(typeof capMeta?.available_cap === 'number' && { available_cap: capMeta.available_cap }),
  };

  return {
    authorizedSpends,
    meta,
    isLoading: isLoadingWithExclusions || isLoadingWithoutExclusions,
  };
};
